import * as EbuOrderingActions from '../actions/ebu-ordering.actions';
import {
  IOrderingError,
  OrderingStatusDataModel,
} from '../../shared/models/ebu-ordering.model';

export interface EbuOrderingState {
  status?: OrderingStatusDataModel;
  error?: IOrderingError;
  isOrdering: boolean;
  optionId: string;
  ebuOrderLockTime: number;
  orderingInput?: any;
  logs?: string;
}

export const initialState: EbuOrderingState = {
  isOrdering: false,
  optionId: '',
  ebuOrderLockTime: 0,
  status: undefined,
  orderingInput: undefined,
  logs: '<b>DEBUG LOGS</b>',
};

export function reducer(
  state: EbuOrderingState = initialState,
  action: EbuOrderingActions.Actions,
): EbuOrderingState {
  switch (action.type) {
    case EbuOrderingActions.ORDER_EBU_REQUEST:
      return {
        ...state,
        isOrdering: false,
        error: undefined,
      };
    case EbuOrderingActions.ORDER_EBU_SUCCESS:
      return {
        ...state,
        status: OrderingStatusDataModel.CONFIRMATION_REQUIRED,
        error: undefined,
      };
    case EbuOrderingActions.ORDER_EBU_CONFIRM_REQUEST:
      return {
        ...state,
        isOrdering: true,
        status: state.status,
        error: undefined,
      };
    case EbuOrderingActions.ORDER_EBU_CONFIRM_FAILURE:
      return {
        ...state,
        isOrdering: false,
        status: OrderingStatusDataModel.ERROR,
        error: action.payload.error.message,
      };
    case EbuOrderingActions.ORDER_EBU_CONFIRM_SUCCESS:
      return {
        ...state,
        isOrdering: false,
        status: action.payload.status,
      };
    case EbuOrderingActions.ORDER_EBU_VALIDATION_REQUIRED_REQUEST:
      return {
        ...state,
        error: undefined,
        status: OrderingStatusDataModel.VALIDATION_REQUIRED,
        isOrdering: false,
        orderingInput: action.payload.orderingInput,
      };
    case EbuOrderingActions.ORDER_EBU_VALIDATION_SUCCESS:
      return {
        ...state,
        isOrdering: false,
        status: action.payload.status,
        orderingInput: undefined,
      };
    case EbuOrderingActions.ORDER_EBU_VALIDATION_FAILURE:
      return {
        ...state,
        isOrdering: false,
        status: OrderingStatusDataModel.ERROR,
      };
    case EbuOrderingActions.ORDER_EBU_VALIDATION_REQUEST:
      return {
        ...state,
        isOrdering: true,
        error: undefined,
      };
    case EbuOrderingActions.ORDER_EBU_LOG:
      return {
        ...state,
        logs: state.logs + '<br>' + action.payload,
      };
    default:
      return state;
  }
}

export const getEbuOrderingStatus = (state: EbuOrderingState) => state.status;

export const getEbuOrderingLockTime = (state: EbuOrderingState) =>
  state.ebuOrderLockTime;

export const getEbuOrderingInput = (state: EbuOrderingState) =>
  state.orderingInput;

export const getEbuOrderingError = (state: EbuOrderingState) => state.error;

export const isEbuOrdering = (state: EbuOrderingState) => state.isOrdering;
export const getEbuOrderingLogs = (state: EbuOrderingState) => state.logs;
